// removed by extract-text-webpack-plugin
module.exports = {"popover":"popover-2PuyP","bottom-center":"bottom-center-1i32e popover-2PuyP","top-center":"top-center-1ADFC popover-2PuyP","middle-right":"middle-right-T-MlI popover-2PuyP","middle-left":"middle-left-16aY6 popover-2PuyP"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/tethers/popover.scss
 ** module id = 46
 ** module chunks = 0
 **/